// extracted by mini-css-extract-plugin
export default {"button":"LargeRoundButton_button__BSuPc","image":"LargeRoundButton_image__s7LZQ","imageMobile":"LargeRoundButton_imageMobile__6pfpb"};